// extracted by mini-css-extract-plugin
export default {"head":"PlayerHead_head__BIplO","player_name":"PlayerHead_player_name__AMFQt","player_info":"PlayerHead_player_info__WIlPB"};